// 项目中一些常量存放文件夹
// 农业 sass 国家常量
export const countrys = {
  europe: [
    'Ukraine',
    'Russia',
    'Germany',
    'Sweden',
    'France',
    'Serbia',
    'United Kingdom',
    'Czech Republic',
    'Poland',
    'Lithuania',
    'Bulgaria',
    'Romania',
    'Hungary',
    'Italy',
    'Denmark',
    'Netherlands',
    'Spain',
    'Austria',
    'Greece',
    'Croatia',
    'Belgium',
    'Slovakia',
    'Ireland',
    'Slovenia',
    'Norway',
    'Belarus',
    'Luxembourg',
    'Portugal',
    'Switzerland',
    'Finland',
    'Iceland',
    'Albania',
    'Estonia',
    'Andorra',
    'North Macedonia',
    'Bosnia and Herzegovina',
    'Vatican',
    'Montenegro',
    'Latvia',
    'Liechtenstein',
    'Malta',
    'Moldova',
    'Monaco',
    'Cyprus',
    'San Marino'
  ],
  usa: [
    'Mexico',
    'United States',
    'Canada',
    'Guatemala',
    'Costa Rica',
    'Belize',
    'salvador',
    'Honduras',
    'Panama',
    'Bahamas',
    'Cuba',
    'Jamaica',
    'Haiti',
    'Dominica',
    'St Kitts and Nevis',
    'Antigua and Barbuda',
    'Dominica',
    'Saint Lucia',
    'St Vincent and the Grenadines',
    'Barbados',
    'Grenada',
    'Trinidad and Tobago',
    'Nicaragua'
  ],
  other: [
    'Turkey',
    'Japan',
    'South Korea',
    'Kazakhstan',
    'Israel',
    'Thailand',
    'Iraq',
    'Philippines',
    'Georgia',
    'Kyrgyzstan',
    'Malaysia',
    'Mongolia',
    'Uzbekistan',
    'Singapore',
    'India',
    'Vietnam',
    'Afghanistan',
    'United Arab Emirates',
    'Oman',
    'Azerbaijan',
    'Pakistan',
    'Palestine',
    'Bahrain',
    'Bhutan',
    'North Korea',
    'East Timor',
    'Cambodia',
    'Qatar',
    'Kuwait',
    'Laos',
    'Lebanon',
    'Maldives',
    'Bangladesh',
    'Myanmar',
    'Nepal',
    'Saudi Arabia',
    'Sri Lanka',
    'Tajikistan',
    'Turkmenistan',
    'Brunei',
    'Syria',
    'Armenia',
    'Yemen',
    'Iran',
    'Indonesia',
    'Jordan',
    'Brazil',
    'Uruguay',
    'Chile',
    'Colombia',
    'Argentina',
    'Paraguay',
    'Venezuela',
    'Bolivia',
    'Ecuador',
    'Guyana',
    'Peru',
    'Suriname',
    'Australia',
    'New Zealand',
    'Vanuatu',
    'Tuvalu',
    'Tonga',
    'Solomon Islands',
    'Samoa',
    'Palau',
    'Niue',
    'Nauru',
    'Federated States of Micronesia',
    'Marshall Islands',
    'Island',
    'Kiribati',
    'Fiji',
    'Papua New Guinea',
    'South Africa',
    'Zambia',
    'Algeria',
    'Egypt',
    'Ethiopia',
    'Angola',
    'Benin',
    'Botswana',
    'Burkina Faso',
    'Burundi',
    'Equatorial Guinea',
    'togo',
    'Eritrea',
    'Cape Verde',
    'Gambia',
    'Congo Republic',
    'DR Congo',
    'Djibouti',
    'Guinea',
    'Guinea-Bissau',
    'Ghana',
    'Gabon',
    'Zimbabwe',
    'Cameroon',
    'Comoros',
    'Ivory Coast',
    'Kenya',
    'Lesotho',
    'Liberia',
    'Libya',
    'Rwanda',
    'Madagascar',
    'Malawi',
    'Mali',
    'Mauritius',
    'Mauritania',
    'Morocco',
    'Mozambique',
    'Namibia',
    'South Sudan',
    'Niger',
    'Nigeria',
    'Sierra Leone',
    'Senegal',
    'Seychelles',
    'Sao Tome and Principe',
    'Swaziland',
    'Sudan',
    'Somalia',
    'Tanzania',
    'Tunisia',
    'Uganda',
    'Chad',
    'Central Africa'
  ]
}
